/* eslint-disable no-console */
'use client';
import { useEffect, useState } from 'react';
import { ProxiedAnalytics } from '../proxies/proxiedAnalytics';
import { initRudder } from '../helpers/initRudderStack';
let hasInitialized = false;
export const useAnalytics = () => {
    const [rudder, setRudder] = useState();
    useEffect(() => {
        let mounted = true;
        if (!rudder && !hasInitialized) {
            hasInitialized = true;
            initRudder()
                .then((analytics) => {
                if (mounted && analytics)
                    setRudder(analytics);
            })
                .catch((error) => {
                console.error('Error initializing RudderStack analytics:', error);
            });
            return () => {
                mounted = false;
            };
        }
    }, [rudder]);
    const analytics = rudder ?? (typeof window === 'undefined' ? undefined : window.rudderanalytics);
    return {
        analytics: analytics ? ProxiedAnalytics : undefined,
        resetAnalytics: () => {
            analytics?.reset(true);
        },
    };
};
